import { Component, Input } from "@angular/core";
import { FulfillmentRequestItem } from "../../models/fulfillment-request-item.model";

@Component({
  selector: "common-fulfillment-item",
  templateUrl: "./fulfillment-item.component.html",
  styleUrls: ["./fulfillment-item.component.scss"],
})
export class FulfillmentItemComponent {
  @Input() fulfillmentId: string;
  @Input() fulfillmentItem: FulfillmentRequestItem;

  constructor() {}

  contactUs() {
    window["HubSpotConversations"]?.widget?.open();
  }
}
